import React, {useMemo, Fragment, useCallback, useState} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import StyledBodySpecialAccordionContentListItem from '../StyledBodySpecialAccordionContentListItem';
import StyledBodySpecialGridPrimaryColumn from '../StyledBodySpecialGridPrimaryColumn';
import StyledBodySpecialGridSecondaryColumn from '../StyledBodySpecialGridSecondaryColumn';
import Ellipses from '../../../../../EllipsesControl/EllipsesPresets';
import {getScotById} from '../../../../../../../selectors/ISA315/selectors';
import {strategyTypes, entities} from '../../../../../../../util/uiconstants';
import {labels} from '../../../../../../../util/utils';
import {useSelector} from 'react-redux';
import ISA315ItAppScotAccordionControlsList from './ISA315ItAppScotAccordionControlsList';
import CreateEditSCOTModalWrapper from '../../../../../EntityCrud/CreateEditSCOTModalWrapper';

function ISA315ItAppScotAccordionContentItem({itApplicationControls, scotId}) {
	const scot = useSelector((state) => getScotById(state, scotId));
	const [showModal, setShowModal] = useState(false);

	const strategy = useMemo(() => {
		let strategyLabel;

		switch (scot.strategyTypeId) {
			case strategyTypes.CONTROLS:
				strategyLabel = labels.strategyType[strategyTypes.CONTROLS].strategyTypeName;
				break;
			case strategyTypes.SUBSTANTIVE:
				strategyLabel = labels.strategyType[strategyTypes.SUBSTANTIVE].strategyTypeName;
				break;
			default:
				strategyLabel = labels.notSelected;
				break;
		}

		return strategyLabel;
	}, [scot]);

	const onEditScotClick = () => {
		setShowModal(!showModal);
	};

	return (
		<Fragment>
			<StyledBodySpecialAccordionContentListItem>
				<StyledItApplicationColumn className="StyledItApplicationColumn">
					<StyledBodySpecialGridPrimaryColumn>
						<span className="styledItApplicationColumnText" onClick={onEditScotClick}>
							<Ellipses.Single>{scot.scotName}</Ellipses.Single>
						</span>
					</StyledBodySpecialGridPrimaryColumn>
				</StyledItApplicationColumn>
				<StyledCountColumn className="StyledCountColumn">
					<StyledBodySpecialGridSecondaryColumn>
						<Ellipses.Single>{strategy}</Ellipses.Single>
					</StyledBodySpecialGridSecondaryColumn>
				</StyledCountColumn>
			</StyledBodySpecialAccordionContentListItem>
			<ISA315ItAppScotAccordionControlsList
				controlIds={scot?.controls?.filter((control) => itApplicationControls.includes(control))}
			/>
			{showModal && (
				<CreateEditSCOTModalWrapper isEdit entityId={scotId} showModal={showModal} setShowModal={setShowModal} />
			)}
		</Fragment>
	);
}

ISA315ItAppScotAccordionContentItem.propTypes = {
	scotId: PropTypes.number.isRequired,
	itApplicationControls: PropTypes.arrayOf(PropTypes.number).isRequired
};

export default ISA315ItAppScotAccordionContentItem;

const StyledItApplicationColumn = styled.section`
	width: calc(100% - var(--px-300));
	.styledItApplicationColumnText {
		cursor: pointer;
		.ellipses {
			width: auto;
		}
		&:hover {
			.ellipses {
				text-decoration: underline;
			}
		}
	}
`;

const StyledCountColumn = styled.section`
	width: var(--px-150);
	padding: 0 var(--px-50) 0 0;
	font-weight: 100;
`;
